import React, { useState } from "react";
import styled from "styled-components";
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogTrigger,
} from "../../components/ui/alert-dialog";
import { Icon } from "../../components/Menu/styles";
import AddNoteIcon from "../../assets/icons/add_notes.svg";
import { FilterButton } from "../../styles/styles_input_pesquisas";
import Close from "../../assets/kinologyIcons/svg/close.svg";
import { Textarea } from "../../components/ui/textarea";
import { DashBoardActions } from "../../store/ducks/dashboard";
import EditSquare from "../../assets/kinologyIcons/svg/edit_square.svg"
import Edit from "../../assets/kinologyIcons/svg/edit.svg"
import { useDispatch } from "react-redux";
import moment from "moment";

interface TypesAddNote {
	edit?: any,
	type: "popover" | "default"
	style?: string
}

const AddNote: React.FC<TypesAddNote> = ({ edit, type, style }) => {
	const dispatch = useDispatch();
	const [nota, setNota] = useState("");

	const handleSave = () => {
		dispatch(DashBoardActions.adicionar_anotacao_dynalabs_request({
			txDataHora: moment(new Date()).format("YYYY-MM-DD HH:mm:ss").toString(),
			ID_FILTRO: 1,
			ANOTACAO_DASH_TXT: nota,
		}));
	};

	const handleEdit = () => {
		dispatch(DashBoardActions.editar_anotacao_dynalabs_request(
			{
				txDataHora: moment(new Date()).format("YYYY-MM-DD HH:mm:ss").toString(),
				ANOTACAO_DASH_TXT: nota,
				ID_ANOTACAO_DASH: edit.ID_ANOTACAO_DASH
			}
		));
	};

	return (
		<AlertDialog>
			<AlertDialogTrigger className={style ? style : ''} >
				{edit?.ID_ANOTACAO_DASH ?
					<div style={{ display: 'flex', flexDirection: 'row', gap: 10 }}  onClick={() => setNota(edit.ANOTACAO_DASH_TXT)}>
						<p style={{ fontSize: "0.9rem", color: '#2A3048', fontWeight: 400 }}>Editar</p>
						<img src={Edit} alt="" style={{ width: '1rem' }} />
					</div>
					:
					type == "default" ?
						<TempoEstimado
							onClick={() => {
								return false;
							}}
						>
							<Icon src={AddNoteIcon} /> Criar anotação
						</TempoEstimado>
						:
						<div style={{ display: 'flex', flexDirection: 'row', gap: 4, cursor: 'pointer' }}>
							<img src={EditSquare} style={{ width: '1.2rem', height: '1.2rem' }}></img>
							<p style={{ fontSize: '1rem', color: '#3D4259', fontWeight: '500' }}>Adicionar anotação</p>
						</div>
				}
			</AlertDialogTrigger>
			<AlertDialogContent
				className="w-[100%] flex flex-col items-center justify-center p-10"
				style={{ width: "50rem", backgroundColor: "#F1F2F3" }}
			>
				<AlertDialogCancel
					style={{ position: "absolute", top: "1rem", right: "1rem", border: 'none', boxShadow: 'none' }}
				>
					<FilterButton
						onClick={() => {
							return false;
						}}
						src={Close}
					/>
				</AlertDialogCancel>

				<Title>Adicionar anotação</Title>

				<div style={{ width: "100%", fontSize: "0.7rem" }}>
					<Title>Anotação</Title>
				</div>
				<div className="grid w-full gap-2">
					<Textarea
						placeholder="Digite aqui"
						style={{ backgroundColor: 'white', height: '13.68rem', color: '#3D4259' }}
						maxLength={2000}
						value={nota}
						onChange={(e) => setNota(e.target.value)}
					/>
					<text style={{ textAlign: 'end', color: '#797D8D' }}>{nota.length}/2000</text>
					<AlertDialogAction
						style={{
							marginTop: "5rem",
							backgroundColor: "#000E4B",
							color: "#FAFAFA",
						}}
						onClick={edit ? handleEdit : handleSave}
					>
						Salvar
					</AlertDialogAction>
				</div>
			</AlertDialogContent>
		</AlertDialog>
	);
};

const TempoEstimado = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	font-family: "NotoSans-Regular";
	font-size: 0.9rem;
	font-weight: 500;
	line-height: 28.8px;
	width: 100%;
	color: #00a377;
	align-items: center;
	padding: 0.1rem;
	border-radius: 0.8rem;
	border: 2px solid var(--Neutras-Grey-K-10, #dedfe3);
`;

const Title = styled.h1`
	color: var(--Primrias-Blue-K-Principal, #000e4b);
	font-family: "NotoSans-Regular";
	font-size: 1.2em;
	font-style: normal;
	font-weight: 700;
	line-height: 104%; /* 29.12px */
`;
export default AddNote;
